import './thefifth4/style';
import FormStructure from './thefifth4/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/kevin/projects/inquiry-renderer/client_forms/includes.js